import _ from 'lodash'
import Vue from 'vue'

Vue.prototype._ = _
